var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCatalogBookDirectory = function SvgCatalogBookDirectory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 208 256",
    enableBackground: "new 0 0 208 256",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.963,100.031H96.277l9.168-30.301L114.963,100.031z M35.8,2H205.82v194.654v0.202 c-13.226,0-23.928,10.702-23.928,23.928s10.702,23.928,23.928,23.928V254H34.084v-0.101C16.416,253.192,2,238.87,2,221 c0-1.514,0-186,0-186C2,16.726,17.526,2,35.8,2z M183.204,196.654l-149.726,0.303c-12.317,0.909-22.111,11.207-22.111,23.726 c0,13.226,10.803,24.029,24.029,23.928h147.505c-6.26-6.058-10.298-14.539-10.298-23.928 C172.603,211.192,176.743,202.712,183.204,196.654z M61.781,146.143h35.196h0.078v-16.937h-9.867l4.196-13.364h28.552l4.196,13.48 h-9.284v16.821h35.196v-16.821h-6.72l-24.746-76.179H93.947l-25.328,76.179h-6.837V146.143z"
  })));
};
export default SvgCatalogBookDirectory;